<template>
  <div class="container">
    <div class="box">
      <div class="columns is-multiline is-mobile filter-section">
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-6-mobile is-3-tablet is-2-desktop">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-12-mobile is-2-tablet is-2-desktop">
          <div class="field">
            <div class="control">
              <label class="label is-hidden-mobile">&nbsp;</label>
              <vs-button
                  ref="button" flat
                  @click="FetchData()"
                  class="form-btn-loading"
                  :loading="loading">
                ຄົ້ນຫາ
              </vs-button>
            </div>
          </div>
        </div>
        <div class="column is-12-mobile is-4-tablet is-3-desktop" v-if="isProcessing">
          <div class="field">
            <div class="control">
              <label class="label is-hidden-mobile">&nbsp;</label>
              <span class="has-text-info">
                <i class="fal fa-spinner-third fa-spin"></i>
                ກຳລັງດຳເນີນການຢູ່... ລໍຖ້າ 3 ນາທີ ແລ້ວກົດຄົ້ນຫາ ອີກຄັ້ງ
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="center fit-width table-scroll-wrapper">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th class="sticky-col col-index">ລຳດັບ</vs-th>
            <vs-th class="sticky-col col-name">ຊື່</vs-th>
            <vs-th class="sticky-col col-code">ລະຫັດ</vs-th>
            <vs-th><div>ສ້າງຕົ້ນທາງ<br>Direct</div></vs-th>
            <vs-th><div>ສ້າງ CDC<br>Direct</div></vs-th>
            <vs-th><div>ສ້າງ CDC ສຳເລັດ<br>Direct</div></vs-th>
            <vs-th><div>ສ້າງຕົ້ນທາງ<br>Pre-Order</div></vs-th>
            <vs-th><div>ສ້າງ CDC<br>Pre-Order</div></vs-th>
            <vs-th><div>ສ້າງ CDC ສຳເລັດ<br>Pre-Order</div></vs-th>
            <vs-th>ຈັດສົ່ງສຳເລັດຕົ້ນທາງ</vs-th>
            <vs-th>ຈັດສົ່ງສຳເລັດ CDC</vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              :data="item"
              v-for="(item, index) in employees">
            <vs-td class="sticky-col col-index">{{ index + 1 }}</vs-td>
            <vs-td class="sticky-col col-name">{{ item.name }}</vs-td>
            <vs-td class="sticky-col col-code">{{ item.user_card_id }}</vs-td>
            <vs-td>
              <div class="cell-stacked">
                <div class="cell-qty">{{ FormatPrice(item.receiveOriginDirectQty) }} <span class="cell-unit">ບິນ</span></div>
                <div class="cell-freight">{{ FormatPrice(item.receiveOriginDirectFreight) }} <span class="cell-unit">ກີບ</span></div>
              </div>
            </vs-td>
            <vs-td>
              <div class="cell-stacked">
                <div class="cell-qty">{{ FormatPrice(item.receiveCdcDirectQty) }} <span class="cell-unit">ບິນ</span></div>
                <div class="cell-freight">{{ FormatPrice(item.receiveCdcDirectFreight) }} <span class="cell-unit">ກີບ</span></div>
              </div>
            </vs-td>
            <vs-td>
              <div class="cell-stacked">
                <div class="cell-qty">{{ FormatPrice(item.receiveCdcSuccessDirectQty) }} <span class="cell-unit">ບິນ</span></div>
                <div class="cell-freight">{{ FormatPrice(item.receiveCdcSuccessDirectFreight) }} <span class="cell-unit">ກີບ</span></div>
              </div>
            </vs-td>
            <vs-td>
              <div class="cell-stacked">
                <div class="cell-qty">{{ FormatPrice(item.receiveOriginPreOrderQty) }} <span class="cell-unit">ບິນ</span></div>
                <div class="cell-freight">{{ FormatPrice(item.receiveOriginPreOrderFreight) }} <span class="cell-unit">ກີບ</span></div>
              </div>
            </vs-td>
            <vs-td>
              <div class="cell-stacked">
                <div class="cell-qty">{{ FormatPrice(item.receiveCdcPreOrderQty) }} <span class="cell-unit">ບິນ</span></div>
                <div class="cell-freight">{{ FormatPrice(item.receiveCdcPreOrderFreight) }} <span class="cell-unit">ກີບ</span></div>
              </div>
            </vs-td>
            <vs-td>
              <div class="cell-stacked">
                <div class="cell-qty">{{ FormatPrice(item.receiveCdcSuccessPreOrderQty) }} <span class="cell-unit">ບິນ</span></div>
                <div class="cell-freight">{{ FormatPrice(item.receiveCdcSuccessPreOrderFreight) }} <span class="cell-unit">ກີບ</span></div>
              </div>
            </vs-td>
            <vs-td>
              <div class="cell-stacked">
                <div class="cell-qty">{{ FormatPrice(item.successOriginQty) }} <span class="cell-unit">ບິນ</span></div>
                <div class="cell-freight">{{ FormatPrice(item.successOriginFreight) }} <span class="cell-unit">ກີບ</span></div>
              </div>
            </vs-td>
            <vs-td>
              <div class="cell-stacked">
                <div class="cell-qty">{{ FormatPrice(item.successCdcQty) }} <span class="cell-unit">ບິນ</span></div>
                <div class="cell-freight">{{ FormatPrice(item.successCdcFreight) }} <span class="cell-unit">ກີບ</span></div>
              </div>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import Loading from "@/views/Loading";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  components: {
    Loading,
    DatePicker,
  },

  data: () => ({
    start_date: moment(new Date()).format('YYYY-MM-DD'),
    end_date: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: false,
    loading: false,
    employees: [],
    isProcessing: false,
  }),

  methods: {
    moment,

    FormatPrice(price) {
      if (price < 1 && price >= 0) {
        return price;
      }
      let p = (parseInt(price) || 0).toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, price, i) {
        return price === "-" ? acc : price + (i && !(i % 3) ? "," : "") + acc;
      }, "");
    },

    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    FetchData() {
      const start = moment(this.start_date);
      const end = moment(this.end_date);
      const diffDays = end.diff(start, 'days');
      if (diffDays < 0) {
        this.$vs.notification({color: 'danger', position: 'top-right', title: 'ວັນທີບໍ່ຖືກຕ້ອງ', text: 'ວັນທີເລີ່ມຕ້ອງນ້ອຍກວ່າວັນທີສິ້ນສຸດ'});
        return;
      }
      if (diffDays > 31) {
        this.$vs.notification({color: 'danger', position: 'top-right', title: 'ໄລຍະເວລາເກີນ', text: 'ສາມາດເລືອກໄດ້ສູງສຸດ 31 ມື້'});
        return;
      }

      this.loading = true;
      this.isLoading = true;
      this.$http.get('branch/employees/shipment/balance-summary', {
        params: {
          start_date: this.start_date,
          end_date: this.end_date,
        }
      }).then((res) => {
        this.employees = res.data.employees;
        this.isProcessing = res.data.status === 'processing';
        this.loading = false;
        this.isLoading = false;
      }).catch((e) => {
        this.loading = false;
        this.isLoading = false;
        if (e.response && e.response.status === 422) {
          this.$vs.notification({color: 'danger', position: 'top-right', title: 'ຂໍ້ມູນບໍ່ຖືກຕ້ອງ', text: 'ກະລຸນາກວດສອບວັນທີ'});
        } else {
          this.$vs.notification({color: 'danger', position: 'top-right', title: 'ເກີດຂໍ້ຜິດພາດ', text: 'ບໍ່ສາມາດໂຫລດຂໍ້ມູນໄດ້'});
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 40px;
}

.filter-section {
  align-items: flex-end;
}

.fit-width {
  white-space: nowrap;
}

.table-scroll-wrapper {
  overflow-x: auto;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
}

.sticky-col {
  position: sticky !important;
  background: #fff !important;
  z-index: 1 !important;
}

.col-index {
  left: 0 !important;
  min-width: 50px;
}

.col-name {
  left: 50px !important;
  min-width: 150px;
}

.col-code {
  left: 200px !important;
  min-width: 90px;
  border-right: 2px solid #e8e8e8 !important;
}

.cell-stacked {
  line-height: 1.4;
}

.cell-qty {
  font-weight: 600;
  color: #195BFF;
}

.cell-freight {
  font-size: 12px;
  color: #333;
}

.cell-unit {
  font-size: 11px;
  font-weight: 400;
  color: #999;
}
</style>
